import { useFormikContext } from "formik";
import { FC, useEffect, useMemo } from "react";
import { RegistrationFormStepResource } from "../shared/types";
import { useRegistrationForm } from "./provider/registrationFormProviderContext";

interface Props {
	step: RegistrationFormStepResource;
}

export const ResetStepFormValuesForHiddenDataFields: FC<Props> = ({ step }) => {
	const { values: stepFormValues, setFieldValue } = useFormikContext<Record<number | string, unknown>>();
	const { getHiddenDataFields, filledSteps } = useRegistrationForm();

	const sectionsGroupedByDataField = useMemo(() => {
		const groupedBy: Record<number, number[]> = {};

		for (const child of step.children) {
			if (child.entityType === "block" || child.section.type !== "default") continue;

			for (const section of child.section.children) {
				if (section.entityType !== "guestAttribute") continue;

				const dataFieldId = section.guestAttribute.dataField.id;
				groupedBy[dataFieldId] = [...(groupedBy[dataFieldId] || []), child.section.id];
			}
		}
		return groupedBy;
	}, [step.children]);

	useEffect(() => {
		const hiddenDataFields = getHiddenDataFields({
			...filledSteps,
			[step.id]: stepFormValues,
		});

		for (const [dataFieldId, sectionsOfDataField] of Object.entries(sectionsGroupedByDataField)) {
			const hiddenInEverySection = sectionsOfDataField.every((sectionId) =>
				hiddenDataFields.includes(`${sectionId}-${dataFieldId}`),
			);

			if (hiddenInEverySection) {
				if (stepFormValues[dataFieldId] !== undefined) {
					void setFieldValue(`${dataFieldId}`, undefined);
				}
			} else if (stepFormValues[dataFieldId] === undefined) {
				void setFieldValue(`${dataFieldId}`, null);
			}
		}
	}, [stepFormValues, step.id, setFieldValue, getHiddenDataFields, filledSteps, sectionsGroupedByDataField]);

	return null;
};
